(() => {
  const setup = root => {
    root.querySelectorAll('.levya-gallery').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = '1';
      const slides = [...gallery.querySelectorAll('.levya-slide')];
      const thumbs = [...gallery.querySelectorAll('[data-gallery-index]')];
      const rail = gallery.querySelector('.levya-thumbs');
      let current = 0;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const show = index => {
        if (!slides.length) return;
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === current);
          if (i !== current) slide.querySelector('video')?.pause();
        });
        thumbs.forEach((button, i) => button.setAttribute('aria-pressed', String(i === current)));
        const thumb = thumbs[current];
        if (thumb) rail.scrollTo({left:thumb.offsetLeft - rail.offsetLeft - (rail.clientWidth - thumb.clientWidth) / 2,behavior:reduced.matches ? 'instant' : 'smooth'});
      };
      thumbs.forEach((button, index) => button.addEventListener('click', () => show(index)));
      gallery.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click', () => show(current + Number(button.dataset.galleryStep))));
      gallery.querySelectorAll('[data-thumb-step]').forEach(button => button.addEventListener('click', () => rail.scrollBy({left:Number(button.dataset.thumbStep) * rail.clientWidth * 0.75,behavior:reduced.matches ? 'instant' : 'smooth'})));
      const stage = gallery.querySelector('.levya-gallery-stage');
      let touchStart;
      stage.addEventListener('touchstart', event => { if (!event.target.closest('video,button')) touchStart = [event.touches[0].clientX,event.touches[0].clientY]; }, {passive:true});
      stage.addEventListener('touchend', event => {
        if (!touchStart) return;
        const dx = event.changedTouches[0].clientX - touchStart[0];
        const dy = event.changedTouches[0].clientY - touchStart[1];
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) show(current + (dx < 0 ? 1 : -1));
        touchStart = undefined;
      }, {passive:true});
      gallery.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); show(current + (event.key === 'ArrowLeft' ? -1 : 1)); }
      });
      show(0);
    });
    root.querySelectorAll('.levya-mobile-menu').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = '1';
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { menu.open = false; }));
      menu.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); } });
    });
    root.querySelectorAll('.levya-form').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = '1';
      const native = form.querySelector('[name=id]');
      const button = form.querySelector('[name=add]');
      const label = button.querySelector('.levya-buy-label');
      const buyLabel = label.dataset.buyLabel || label.textContent;
      const selects = [...form.querySelectorAll('.levya-option')];
      const variants = JSON.parse(form.querySelector('[data-levya-variants]').textContent);
      const apply = (variant, updateUrl) => {
        if (variant) native.value = String(variant.id);
        else native.value = '';
        button.disabled = !variant?.available;
        label.textContent = variant ? (variant.available ? buyLabel : window.variantStrings?.soldOut || 'Épuisé') : window.variantStrings?.unavailable || 'Indisponible';
        if (variant) {
          const nativeOption = [...native.options].find(option => option.value === String(variant.id));
          if (nativeOption?.dataset.price) document.querySelectorAll('.shop-product-price-container,.levya-sticky-price').forEach(price => price.textContent = nativeOption.dataset.price);
          form.closest('.levya-purchase').querySelectorAll('[data-size-choice]').forEach(choice => choice.setAttribute('aria-pressed', String(variant.options.includes(choice.dataset.sizeChoice))));
          if (updateUrl && !window.Shopify?.designMode) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState(window.history.state, '', url);
          }
        }
      };
      const initial = variants.find(variant => String(variant.id) === native.value);
      selects.forEach(select => {
        if (initial) select.value = initial.options[Number(select.dataset.optionIndex)];
        select.addEventListener('change', () => {
          const options = selects.map(item => item.value);
          const variant = variants.find(item => item.options.every((value, index) => value === options[index]));
          apply(variant, true);
        });
      });
      if (selects.length) {
        form.querySelector('.levya-option-grid').hidden = false;
        form.querySelector('.levya-native-picker').hidden = true;
      }
      native.addEventListener('change', () => {
        const variant = variants.find(item => String(item.id) === native.value);
        if (variant) selects.forEach(select => select.value = variant.options[Number(select.dataset.optionIndex)]);
        apply(variant, true);
      });
      apply(initial, false);
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (!native.value) return;
        const error = form.querySelector('.levya-cart-error');
        error.hidden = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {method:'POST', body:new FormData(form), headers:{Accept:'application/json'}});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message);
          window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
        } catch (failure) {
          error.textContent = failure.message;
          error.hidden = false;
          apply(variants.find(item => String(item.id) === native.value), false);
          button.removeAttribute('aria-busy');
        }
      });
    });
    root.querySelectorAll('[data-size-open]:not([data-lsg-opener])').forEach(opener => {
      if (opener.dataset.ready) return;
      opener.dataset.ready = '1';
      const dialog = document.getElementById(opener.getAttribute('aria-controls'));
      opener.addEventListener('click', () => dialog.showModal());
      dialog.querySelector('[data-size-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.querySelectorAll('[data-size-choice]').forEach(choice => {
        choice.addEventListener('click', () => {
          const form = dialog.closest('.levya-purchase').querySelector('.levya-form');
          const select = [...form.querySelectorAll('.levya-option')].find(option => [...option.options].some(value => value.value === choice.dataset.sizeChoice));
          if (select) { select.value = choice.dataset.sizeChoice; select.dispatchEvent(new Event('change', {bubbles:true})); }
          dialog.close();
        });
      });
    });
    const purchase = document.querySelector('.levya-purchase');
    const sticky = document.querySelector('[data-levya-sticky]');
    if (purchase && sticky && !sticky.dataset.ready) {
      sticky.dataset.ready = '1';
      new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0; }, {threshold:0}).observe(purchase);
    }
  };
  class LevyaAutoGallery extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const viewport = this.querySelector('.levya-auto-viewport');
      const track = this.querySelector('.levya-auto-track');
      const toggle = this.querySelector('.levya-auto-toggle');
      const originals = [...track.children];
      if (!originals.length) { toggle.hidden = true; return; }
      const controller = new AbortController();
      this.controller = controller;
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let enabled = this.dataset.autoplay === 'true' && !motion.matches;
      let visible = false;
      let hovered = false;
      let focused = false;
      let loopWidth = 0;
      let frame;
      let lastTime;
      let interactionUntil = 0;
      const cloneGroup = () => originals.forEach(item => {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
        clone.querySelectorAll('img').forEach(image => { image.alt = ''; image.loading = 'eager'; });
        track.append(clone);
      });
      cloneGroup();
      const measure = () => {
        loopWidth = track.children[originals.length].offsetLeft - originals[0].offsetLeft;
        for (let count = 0; count < 10 && track.scrollWidth < viewport.clientWidth + loopWidth; count++) cloneGroup();
      };
      measure();
      const mayRun = () => enabled && visible && !hovered && !focused && !document.hidden && loopWidth > 0;
      const renderToggle = () => {
        toggle.textContent = enabled ? '❚❚' : '▶';
        toggle.setAttribute('aria-label', enabled ? toggle.dataset.pauseLabel : toggle.dataset.playLabel);
        toggle.setAttribute('aria-pressed', String(!enabled));
      };
      const tick = time => {
        if (!mayRun()) { frame = undefined; this.dataset.playing = 'false'; return; }
        const elapsed = lastTime ? Math.min(time - lastTime, 64) : 0;
        lastTime = time;
        if (time > interactionUntil) viewport.scrollLeft = (viewport.scrollLeft + elapsed * Number(this.dataset.speed || 30) / 1000) % loopWidth;
        this.dataset.playing = 'true';
        frame = requestAnimationFrame(tick);
      };
      const schedule = () => {
        if (!mayRun()) { cancelAnimationFrame(frame); frame = undefined; lastTime = undefined; this.dataset.playing = 'false'; }
        else if (!frame) { lastTime = undefined; frame = requestAnimationFrame(tick); }
      };
      toggle.addEventListener('click', () => { enabled = !enabled; renderToggle(); schedule(); }, {signal:controller.signal});
      this.addEventListener('mouseenter', () => { hovered = this.dataset.pauseHover === 'true'; schedule(); }, {signal:controller.signal});
      this.addEventListener('mouseleave', () => { hovered = false; schedule(); }, {signal:controller.signal});
      this.addEventListener('focusin', event => { focused = event.target !== toggle; schedule(); }, {signal:controller.signal});
      this.addEventListener('focusout', () => { focused = false; schedule(); }, {signal:controller.signal});
      viewport.addEventListener('pointerdown', () => { interactionUntil = performance.now() + 3500; }, {signal:controller.signal});
      document.addEventListener('visibilitychange', schedule, {signal:controller.signal});
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }, {threshold:0.1});
      observer.observe(this);
      const resize = new ResizeObserver(() => { measure(); schedule(); });
      resize.observe(viewport);
      renderToggle();
      let beforeEditor;
      this.selectForEditor = item => { if (beforeEditor === undefined) beforeEditor = enabled; enabled = false; renderToggle(); schedule(); viewport.scrollLeft = item.offsetLeft; };
      this.resumeFromEditor = () => { if (beforeEditor !== undefined) { enabled = beforeEditor; beforeEditor = undefined; renderToggle(); schedule(); } };
      this.cleanup = () => { cancelAnimationFrame(frame); observer.disconnect(); resize.disconnect(); controller.abort(); [...track.children].slice(originals.length).forEach(item => item.remove()); };
    }
    disconnectedCallback() { this.cleanup?.(); this.controller = undefined; }
  }
  if (!customElements.get('levya-auto-gallery')) customElements.define('levya-auto-gallery', LevyaAutoGallery);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(document), {once:true});
  else setup(document);
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:block:select', event => {
    const slide = event.target.closest('.levya-slide');
    if (slide) {
      const gallery = slide.closest('.levya-gallery');
      gallery.querySelectorAll('.levya-slide').forEach(item => { item.classList.toggle('is-active', item === slide); if (item !== slide) item.querySelector('video')?.pause(); });
      gallery.querySelectorAll('[data-gallery-index]').forEach(item => item.setAttribute('aria-pressed', String(item.dataset.galleryIndex === slide.dataset.slide)));
    }
    const photo = event.target.closest('.levya-auto-item');
    if (photo) photo.closest('levya-auto-gallery')?.selectForEditor?.(photo);
    const dialog = event.target.closest('.levya-size-dialog');
    if (dialog && !dialog.open) dialog.showModal();
  });
  document.addEventListener('shopify:block:deselect', event => {
    event.target.closest('levya-auto-gallery')?.resumeFromEditor?.();
    event.target.closest('.levya-size-dialog')?.close();
  });
})();

